import { toast } from 'react-toastify';

/* A request that never reached the server — a timeout, an offline blip, an aborted
   navigation — rejects with an error that has no `response` at all. Reading through it
   unguarded threw a TypeError of its own, which replaced the real failure in Sentry and
   left the member with no message. */
const getErrorObject = (error: any) => error?.response?.data?.error;

export const handleErrorMessage = (error: any) => {
  const _error = getErrorObject(error);

  const singleError = _error?.detail;
  const multipleErrors = _error?.errorList;
  const zipCodeError = multipleErrors?.address?.postalCode?.[0];

  const emailError =
    singleError ===
      'The contract has not been finished yet. Click here to receive an email to continue your contract.' ||
    singleError === 'User with this email already exists.';

  const errorCustomMessage = {
    zipCodeError,
    emailError,
  };

  /* Callers own the message for these two — they open the waitlist or flag the email field. */
  if (emailError || zipCodeError) {
    return errorCustomMessage;
  }

  if (_error) {
    if (!multipleErrors) {
      toast.error(singleError, {
        autoClose: false,
      });
    } else {
      toast.error(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `Validation failed on field(s) ${Object.keys(
          multipleErrors
        )}`,
        {
          autoClose: false,
        }
      );
    }
  } else {
    toast.error('Unexpected error. Please, try again.', {
      autoClose: false,
    });
  }

  /* Always an object: `PersonalInformation` and `BasicInfo` destructure the result. */
  return errorCustomMessage;
};
